module.exports = __webpack_public_path__ + "static/img/faisal-2.e5e3fea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/faisal-2.png
// module id = GdSj
// module chunks = 1